import { Guid, Nillable } from '@web/utils';
import { AdminBoxStatus } from '../enums/admin-box-status';
import { Multimedia } from '@web/shared/module/multimedia';
import { AdminBoxAttributeDetails } from './admin-box-attribute-details';
import { AdminBoxCharacteristicDetails } from './admin-box-characteristic-details';
import { AdminBoxCosmetic } from './admin-box-cosmetic';

export class AdminBoxDetails {
  public constructor(
    private readonly data: {
      boxCategoryName?: Nillable<string>;
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeWarehouseProductIdEdited?: Nillable<boolean>;
      canBeViewed: boolean;
      cosmeticBrandName?: Nillable<string>;
      cosmetics: AdminBoxCosmetic[];
      createdAt: Date;
      publishedAt: Nillable<Date>;
      featuredFile?: Nillable<Multimedia>;
      files: Multimedia[];
      id: Guid;
      illustrationFile?: Nillable<Multimedia>;
      name: string;
      password?: Nillable<string>;
      price?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      maxQuantityPerOrder?: Nillable<number>;
      contentPreviewUrl?: Nillable<string>;
      currentEdition?: Nillable<boolean>;
      slug: string;
      status: AdminBoxStatus;
      symbolFile?: Nillable<Multimedia>;
      warehouseProductName?: Nillable<string>;
      attributes: AdminBoxAttributeDetails[];
      characteristics: AdminBoxCharacteristicDetails[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }
  public get name(): string {
    return this.data.name;
  }
  public get slug(): string {
    return this.data.slug;
  }
  public get password(): Nillable<string> {
    return this.data.password;
  }
  public get createdAt(): Date {
    return this.data.createdAt;
  }
  public get publishedAt(): Nillable<Date> {
    return this.data.publishedAt;
  }
  public get symbolFile(): Nillable<Multimedia> {
    return this.data.symbolFile;
  }
  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }
  public get illustrationFile(): Nillable<Multimedia> {
    return this.data.illustrationFile;
  }
  public get status(): AdminBoxStatus {
    return this.data.status;
  }
  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }
  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }
  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
  public get files(): Multimedia[] {
    return this.data.files;
  }
  public get price(): Nillable<number> {
    return this.data.price;
  }
  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }
  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }
  public get cosmetics(): AdminBoxCosmetic[] {
    return this.data.cosmetics;
  }
  public get boxCategoryName(): Nillable<string> {
    return this.data.boxCategoryName;
  }
  public get warehouseProductName(): Nillable<string> {
    return this.data.warehouseProductName;
  }
  public get maxQuantityPerOrder(): Nillable<number> {
    return this.data.maxQuantityPerOrder;
  }
  public get contentPreviewUrl(): Nillable<string> {
    return this.data.contentPreviewUrl;
  }
  public get shopPreviewUrl(): Nillable<string> {
    return this.data.slug;
  }
  public get currentEdition(): Nillable<boolean> {
    return this.data.currentEdition;
  }
  public get attributes(): AdminBoxAttributeDetails[] {
    return this.data.attributes;
  }
  public get characteristics(): AdminBoxCharacteristicDetails[] {
    return this.data.characteristics;
  }
  public get canBeWarehouseProductIdEdited(): Nillable<boolean> {
    return this.data.canBeWarehouseProductIdEdited;
  }
}
